import axios from "axios";
import {updateIndexPage, updateToken} from "../redux/reducers/voucherPortalFormReducer";
import i18n from "../resources/i18nSetup";




export default async   function callHttp(url, method, param,  body, headers,thunkApi,baseConfig={},isAuthorization = true) {
    let baseUrl = process.env.REACT_APP_SERVER_API;
    const apiProxy = axios.create();
    apiProxy.interceptors.request.use((config) => {
      config.headers = headers || config.headers;
      return config;
    });
    let config = {
        ...baseConfig,
        method: method,
        url: `${baseUrl}/${url}`,
        params: {},
        data: {},
    };
    if (param) {
      config['params'] = param;
    }
    if (body) {
      config['data'] = body
    }

    if (isAuthorization) {
        config['headers'] = {
            'X-Csrf-Token': localStorage.getItem('csrf_token') ? `${JSON.parse(localStorage.getItem('csrf_token'))}` : null
        }
    }

    try {
      const axiosResponse = await apiProxy(config);
      if (axiosResponse.status >= 200 && axiosResponse.status <= 206) {
        return  axiosResponse.data;
      }
      }
     catch (error) {
       if (error.response.status === 401 && url != 'setCSRFToken') {//unautorization
         localStorage.removeItem('csrf_token')
         if (thunkApi){
           const state = thunkApi.getState()
           if (state.VoucherPortalFormReducer.indexPage == 0){
             thunkApi.dispatch(updateToken(true))

           }
             else{
             thunkApi.dispatch(updateIndexPage(0))

           }


         }
       }
       else if (error.response.status === 429) {//rate limit error code
         window.alert(i18n.t('tryAgainLaterError'))
       }
       else  {
         window.alert(error.response.data.message)
         if (thunkApi){
           return   thunkApi.rejectWithValue(error.response.data.message)

         }
       }
      throw new Error('recieve error');
    }
}



